import { render, staticRenderFns } from "./dr-combo-box.vue?vue&type=template&id=3187c58c"
import script from "./dr-combo-box.vue?vue&type=script&lang=js"
export * from "./dr-combo-box.vue?vue&type=script&lang=js"
import style0 from "./dr-combo-box.vue?vue&type=style&index=0&id=3187c58c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports